import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { LANDING } from '@/constants/testIds';

const ProgramVideo = () => {
    const [playing, setPlaying] = useState(false);
    const videoRef = useRef(null);

    const handlePlay = () => {
        setPlaying(true);
        requestAnimationFrame(() => videoRef.current?.play());
    };

    return (
        <section
            id="video"
            data-testid={LANDING.videoSection}
            className="relative py-16 md:py-24 border-t border-white/10 overflow-hidden"
        >
            <div
                className="pointer-events-none absolute -top-32 right-0 h-[420px] w-[420px] rounded-full"
                style={{ background: 'radial-gradient(closest-side, rgba(225,29,72,0.14), transparent 70%)' }}
            />
            <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-5 md:gap-8 mb-10 items-end">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="col-span-12 md:col-span-7"
                    >
                        <div className="eyebrow-brand mb-6">La misión en video</div>
                        <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                            El programa, contado <span className="italic-accent text-[color:var(--brand)] font-normal">en primera persona.</span>
                        </h2>
                    </motion.div>
                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                        className="col-span-12 md:col-span-4 md:col-start-9 text-white/70 leading-relaxed"
                    >
                        Cinco minutos para entender cómo funciona la Misión FITUR 2027,
                        a quién está pensada y qué te llevas de vuelta a casa.
                    </motion.p>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-80px' }}
                    transition={{ duration: 0.8 }}
                    className="relative border border-white/12 bg-black overflow-hidden"
                    style={{ boxShadow: '0 40px 90px -30px rgba(0,0,0,0.7)' }}
                >
                    <div className="relative aspect-video">
                        <video
                            ref={videoRef}
                            data-testid={LANDING.videoPlayer}
                            className="h-full w-full object-cover"
                            poster="/assets/mision-fitur-poster.jpg"
                            preload="none"
                            playsInline
                            controls={playing}
                        >
                            <source src="/assets/mision-fitur-2027-720.mp4" type="video/mp4" />
                            <source src="/assets/mision-fitur-2027-720.webm" type="video/webm" />
                        </video>
                        {!playing && (
                            <button
                                type="button"
                                data-testid={LANDING.videoPlay}
                                onClick={handlePlay}
                                className="group absolute inset-0 flex items-center justify-center bg-gradient-to-t from-black/70 via-black/25 to-black/10 transition-colors duration-500 hover:from-black/60"
                                aria-label="Reproducir video del programa"
                            >
                                <span className="flex flex-col items-center gap-5">
                                    <span className="relative flex h-20 w-20 md:h-24 md:w-24 items-center justify-center rounded-full bg-[color:var(--brand)] transition-transform duration-500 group-hover:scale-110">
                                        <span className="absolute inline-flex h-full w-full rounded-full bg-[color:var(--brand)] opacity-50 animate-ping" />
                                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" className="relative ml-1">
                                            <path d="M6 4.5v15l13-7.5-13-7.5z" fill="white" />
                                        </svg>
                                    </span>
                                    <span className="text-[11px] md:text-xs uppercase tracking-[0.28em] text-white/85 font-semibold">
                                        Ver la misión · 4:53
                                    </span>
                                </span>
                            </button>
                        )}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default ProgramVideo;
